/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sol_Ukm_D2dInputs */

const en_mk_sol_ukm_d2d = /** @type {(inputs: Mk_Sol_Ukm_D2dInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The agent drafts a reply using the stored language rules; a person just checks it and sends.`)
};

const id_mk_sol_ukm_d2d = /** @type {(inputs: Mk_Sol_Ukm_D2dInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agen menyiapkan draf balasan berdasarkan aturan bahasa yang tersimpan; orang tinggal memeriksa dan mengirim.`)
};

/**
* | output |
* | --- |
* | "The agent drafts a reply using the stored language rules; a person just checks it and sends." |
*
* @param {Mk_Sol_Ukm_D2dInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sol_ukm_d2d = /** @type {((inputs?: Mk_Sol_Ukm_D2dInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sol_Ukm_D2dInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sol_ukm_d2d(inputs)
	return en_mk_sol_ukm_d2d(inputs)
});